/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable react/no-unknown-property */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { COUNTRY } from "../../../constants/app-constants";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { appUrl } from "../../../constants/url-constants";
import { Helmet } from "react-helmet";

const CDPBreadCrumb = ({
    carName,
    city = "",
    make = "",
    model = "",
    match,
    reloadCarListConnect
}) => {
    const { path, url } = match;
    const isDetailsPage = path === "/buy-used-:carMakeModel-car-:lid(\\d+)";
    const countrySlug = ((COUNTRY.slug).replace(/ /g, "-")).toLowerCase();
    const citySlug = city && (city.replace(/ /g, "-")).toLowerCase();
    const makeSlug = make && (make.replace(/ /g, "-")).toLowerCase();
    const modelSlug = model && (model.replace(/ /g, "-")).toLowerCase();

    const trackEvent = (eventLabel) => {
        trackDesktopCustomEventsAU("breadcrumbsDetailPage", {
            eventLabel
        });
    };

    const createBreadCrumbPath = (isCityPath, cityName, makeModelData = {}) => {
        const {make: makeName = "", model: modelName = ""} = makeModelData || {};
        if (isCityPath) {
            return cityName ? `Used cars in ${cityName}` : "";
        } else if (cityName) {
            return makeName && modelName ? `Used ${makeName} ${modelName} in ${cityName}` : `Used ${makeName} in ${cityName}`;
        }
        return "";
    };

    const onClickCityName = () => {
        reloadCarListConnect(true);
        trackEvent(`/buy-used-cars-${countrySlug}/`);
    };

    const list = [
        {
            name: "Home",
            link: `${appUrl()}/`,
            handleClick: () => trackEvent(`/`)
        },
        {
            name: `Used Cars in ${COUNTRY.name}`,
            link: `${appUrl()}/buy-used-cars-${countrySlug}/`,
            handleClick: onClickCityName
        }
    ];

    if (citySlug) {
        const cityPath = createBreadCrumbPath(true, city);
        if (cityPath) {
            list.push(
                {
                    name: cityPath,
                    link: `${appUrl()}/buy-used-cars-in-${citySlug}/`,
                    handleClick: () => null
                }
            );
        }
    }

    if (makeSlug) {
        const makeCityPath = createBreadCrumbPath(false, city, {make});
        if (makeCityPath) {
            list.push(
                {
                    name: makeCityPath,
                    link: city ? `${appUrl()}/buy-used-${makeSlug}-cars-in-${citySlug}/` : `${appUrl()}/buy-used-${makeSlug}/`,
                    handleClick: () => null
                }
            );
        }
    }

    if (modelSlug) {
        const makeModelCityPath = createBreadCrumbPath(false, city, {make, model});
        if (makeModelCityPath) {
            list.push(
                {
                    name: makeModelCityPath,
                    link: city ? `${appUrl()}/buy-used-${makeSlug}-${modelSlug}-cars-in-${citySlug}/` : `${appUrl()}/buy-used-${makeSlug}/`,
                    handleClick: () => null
                }
            );
        }
    }

    if (isDetailsPage) {
        if (carName) {
            list.push(
                {
                    name: carName,
                    link: `${appUrl()}${url}`,
                    handleClick: () => null
                }
            );
        }
    }

    const schema = JSON.stringify(
        {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement":
                list.map((l, i) => {
                    const isLastItem = list.length - 1 === i;

                    return ({
                        "@type": "ListItem",
                        "position": `${i + 1}`,
                        "name": l.name,
                        ...(!isLastItem && { "item": l.link })
                    });
                })
        }
    );

    return (
        <React.Fragment>
            <Helmet script={[
                {
                    type: "application/ld+json",
                    innerHTML: schema
                }
            ]} />
            <div className="container" styleName={"styles.wrap"}>
                <nav aria-label="breadcrumb">
                    <ul className="breadcrumb">
                        {list.map((l, i) => {
                            const isLastItem = list.length - 1 === i;
                            return (
                                <li key={i} className="breadcrumb-item" styleName={isLastItem ? "styles.noDisplayLink" : ""} title={l.name}>
                                    {isLastItem ? l.name : <a href={l.link} onClick={l.handleClick}>{l.name}</a>}
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </React.Fragment>
    );
};

CDPBreadCrumb.propTypes = {
    carName: PropTypes.string,
    city: PropTypes.string,
    make: PropTypes.string,
    model: PropTypes.string,
    match: PropTypes.object,
    reloadCarListConnect: PropTypes.func
};

export default CDPBreadCrumb;
